export default {
  LIST(state, data) {
    state.protocols = data
  },
  GET(state, data) {
    state.protocol = data
  },
  UPDATE(state, value) {
    state.protocol = {
      ...value,
    }
  },
  FRESH(state) {
    state.protocol = {
      id: null,
      protocol_number: '',
      protocol_date: null,
      file: null,
      file_upload: null,
    }
  },
}
